module.exports = __webpack_public_path__ + "img/news3-2.81f1c359.png";